// src/components/layout/SocialBadges.js
import React from 'react';
import styled from 'styled-components';

const BadgesWrapper = styled.div`
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 99;
  display: flex;
  flex-direction: column;

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    display: none;
  }
`;

const Badge = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  background-color: #fff;
  border-radius: 10px 0 0 10px;
  box-shadow: -3px 3px 12px rgba(0,0,0,0.18);
  text-decoration: none;
  overflow: hidden;
  padding: 10px;
  margin-bottom: 8px;
  transform: translateX(4px);
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:last-child {
    margin-bottom: 0;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }

  &:hover {
    transform: translateX(0);
    box-shadow: -5px 3px 16px rgba(0,0,0,0.25);
  }
`;

const PJBadge = styled(Badge)`
  background-color: #FFDE07;
  padding: 10px;
`;

const PJText = styled.span`
  font-size: 1.3rem;
  font-weight: 900;
  color: #1a1a1a;
  font-family: Arial, sans-serif;
  letter-spacing: -1px;
`;

const SocialBadges = () => {
  return (
    <BadgesWrapper>
      {/* Houzz */}
      <Badge
        href="https://www.houzz.fr/pro/olivierdiard"
        target="_blank"
        rel="noopener noreferrer"
        title="Retrouvez-nous sur Houzz"
      >
        <img src="/hhouzz.png" alt="Houzz" />
      </Badge>

      {/* Google Avis */}
      <Badge
        href="https://www.google.com/search?sca_esv=f23db4616a8d669b&hl=fr-FR&sxsrf=ANbL-n4kLylITcFuac-2MS9N7VuT1Itrag:1774629775280&si=AL3DRZEsmMGCryMMFSHJ3StBhOdZ2-6yYkXd_doETEE1OR-qOWmQcvXKPPpE9C-_OqOtjZdiSzu5CLeN9N2BDi1QA-Q27UM3upDS0YHaq4QWhQTnvsHxPRCLRxrB52-Ub-xnZFuLemv4&q=DECKO+Terrasses+Avis&sa=X&ved=2ahUKEwju7fOKw8CTAxUTZqQEHdqyPBEQ0bkNegQIIxAH&biw=1536&bih=695&dpr=1.25"
        target="_blank"
        rel="noopener noreferrer"
        title="Nos avis Google"
      >
        <img src="/logo-google-avis (1).png" alt="Avis Google" />
      </Badge>

      {/* Pages Jaunes */}
      <PJBadge
        href="https://www.pagesjaunes.fr/pros/detail?code_etablissement=51550850&code_localite=L04421500&code_rubrique=904210"
        target="_blank"
        rel="noopener noreferrer"
        title="Notre fiche Pages Jaunes"
      >
        <img src="/logo-pagesjaunes-c390b53cc7 (1).svg" alt="Pages Jaunes" />
      </PJBadge>
    </BadgesWrapper>
  );
};

export default SocialBadges;
